module.exports = __webpack_public_path__ + "static/media/pic1.8262bc6e.png";